import { AppDispatch, RootState } from "@/services/state/store";
import {
  Box,
  HStack,
  Icon,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Portal,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Textarea,
  VStack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "../Table/Table";
import { TiPlus } from "react-icons/ti";
import { AddProcessVaraibleModal } from "../AddProcessVariableModal/AddProcessVariableModal";
import React, { useEffect, useState } from "react";
import { ExpressionEditorModal } from "../ExpressionEditorModal/ExpressionEditorModal";
import { BrandButton } from "../BrandButton/BrandButton";
import { FiMoreHorizontal, FiEdit2 } from "react-icons/fi";
import { MdOutlineDelete } from "react-icons/md";
import { ProcessVariable } from "../../services/state/Process-modular/ProcessVaraible-interface";
import { getAxiosClient } from "../../services/HttpsService";
import {
  fetchProcessByUuid,
  fetchProcesses,
} from "../../services/state/processes/processes-async-calls";
import { setProcessVariables } from "../../services/state/Process-modular/processModular";
import { setSelectedProcess } from "../../services/state/processes/processes";
import { BiEdit } from "react-icons/bi";

export const ProcessModelPropertiesModal = ({
  isOpen,
  onClose,
  video,
  isInstanceBased,
}: {
  isOpen: boolean;
  onClose: () => void;
  video: string;
  isInstanceBased?: boolean;
}) => {
  const dispatch: AppDispatch = useDispatch();
  const {
    isOpen: isPvModelOpen,
    onOpen: onPvModeOpen,
    onClose: onPvModeClose,
  } = useDisclosure();

  const {
    isOpen: isPvEditModelOpen,
    onOpen: onPvEditModeOpen,
    onClose: onPvEditModeClose,
  } = useDisclosure();

  const {
    isOpen: isPvDeleteModelOpen,
    onOpen: onPvDeleteModeOpen,
    onClose: onPvDeleteModeClose,
  } = useDisclosure();

  const toast = useToast();

  const {
    isOpen: isExpressionEditorModalOpen,
    onOpen: onExpressionEditorModalOpen,
    onClose: onExpressionEditorModalClose,
  } = useDisclosure();

  const [processName, setProcessName] = useState<string | undefined>();
  const [processDescription, setProcessDescription] = useState<string>();
  const [processDisplayName, setProcessDisplayName] = useState<string>();
  const [editProcessVariable, setEditProcessVariable] = useState<any>();
  const [edit, setEdit] = useState<boolean>(false);

  const selectedProcess = useSelector(
    (state: RootState) => state.processes.selectedProcess
  );

  const processVariables = useSelector(
    (state: RootState) => state.processModeler.processVariables
  );

  const processInstanceVariablesInfo = useSelector(
    (state: RootState) => state.monitor.processInstanceVariablesInfo
  );

  const processVariablesColumns = [
    {
      Header: "Process Variables",
      accessor: "processVariables",
    },
  ];

  const processVariablesColumnData = [
    {
      processVariables: (
        <HStack onClick={onPvModeOpen} cursor="pointer" gap={2}>
          <Icon as={TiPlus as React.ElementType} />
          <Text textColor="brand.400">Add Variable</Text>
        </HStack>
      ),
    },
  ];

  const onProcessVariableEditClick = (id: string) => {
    console.log("onProcessVariableEditClick", id);
    setEditProcessVariable(processVariables.find((pv) => pv.uuid === id));
    setEdit(true);
    onPvEditModeOpen();
  };

  const onProcessVariableDeleteClick = (id: string) => {
    // Filter out the process variable with the matching uuid
    const updatedProcessVariables = processVariables.filter(
      (pv) => pv.uuid !== id
    );
    // Dispatch the updated process variables
    dispatch(setProcessVariables(updatedProcessVariables));
  };

  const handleValue = (value: string) => {
    setProcessDisplayName(value);
  };

  const columns = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Value",
      accessor: "value",
    },
    {
      Header: "Parameter?",
      accessor: "parameter",
    },
    {
      Header: "Required",
      accessor: "required",
    },
    {
      Header: "Multiple",
      accessor: "multiple",
    },
    // {
    //   Header: "Hidden",
    //   accessor: "hidden",
    // },
    {
      Header: "",
      accessor: "actions",
    },
  ];

  const columns1 = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Value",
      accessor: "value",
    },
    {
      Header: "Parameter?",
      accessor: "parameter",
    },
    {
      Header: "Required",
      accessor: "required",
    },
    {
      Header: "Multiple",
      accessor: "multiple",
    },
    {
      Header: "Hidden",
      accessor: "hidden",
    },
  ];

  const columnData = processVariables?.map((pv) => {
    return {
      name: pv.varNm,
      type: pv.dataTypeCd,
      value: pv.varDefVal,
      parameter: String(pv.isParam),
      required: String(pv.isMandatory),
      multiple: String(pv.isMultiple),
      hidden: String(pv.isParam),
      actions: (
        <Menu placement="bottom-end">
          <MenuButton
            as={IconButton as React.ElementType}
            aria-label="Actions"
            icon={
              <Icon as={FiMoreHorizontal as React.ElementType} boxSize="18px" />
            }
            variant="outline"
            size="sm"
            colorScheme="gray"
            bg="rgba(255, 255, 255, 0.1)"
            borderColor="rgba(255, 255, 255, 0.3)"
            color="white"
            _hover={{
              bg: "rgba(255, 255, 255, 0.2)",
              borderColor: "brand.400",
            }}
            borderRadius={"md"}
          />
          <Portal>
            <MenuList
              bg="rgba(0, 0, 0, 0.95)"
              backdropFilter="blur(20px)"
              border="1px solid rgba(255, 255, 255, 0.4)"
              borderRadius="8px"
              boxShadow="0 8px 32px rgba(0, 0, 0, 0.5)"
              zIndex={9999}
              minW="120px"
            >
              <MenuItem
                icon={<Icon as={FiEdit2 as React.ElementType} boxSize="18px" />}
                onClick={() => onProcessVariableEditClick(pv.uuid)}
                bg="transparent"
                color="white"
                _hover={{
                  bg: "rgba(118, 82, 247, 0.2)",
                  color: "white",
                }}
                _focus={{
                  bg: "rgba(118, 82, 247, 0.2)",
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                icon={
                  <Icon
                    as={MdOutlineDelete as React.ElementType}
                    boxSize="18px"
                  />
                }
                onClick={() => onProcessVariableDeleteClick(pv.uuid)}
                bg="transparent"
                color="white"
                _hover={{
                  bg: "rgba(220, 38, 38, 0.2)",
                  color: "red.300",
                }}
                _focus={{
                  bg: "rgba(220, 38, 38, 0.2)",
                }}
              >
                Delete
              </MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      ),
    };
  });

  const columnData1 = processInstanceVariablesInfo?.map((pv) => {
    return {
      name: pv.processVar.varNm,
      type: pv.processVar.dataType.dataTypNm,
      value: pv.varVal,
      parameter: String(pv.processVar.isParam),
      required: String(pv.processVar.isMandatory),
      multiple: String(pv.processVar.isMultiple),
      hidden: String(pv.processVar.isParam),
    };
  });

  const onUpdate = async () => {
    console.log("selectedProcess", selectedProcess);
    if (processName !== "" && selectedProcess) {
      const updatedProcess = {
        ...selectedProcess,
        processNm: processName!!,
        processDnm: processDisplayName || "",
        processDesc: processDescription || "",
      };
      dispatch(setSelectedProcess(updatedProcess));
    } else {
      toast({
        title: "Name is required",
        description: "Please enter a name and try again",
        position: "top",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    onClose();
  };

  useEffect(() => {
    setProcessName(selectedProcess?.processNm);
    setProcessDescription(selectedProcess?.processDesc);
    setProcessDisplayName(selectedProcess?.processDnm);
  }, [selectedProcess]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"4xl"}>
      <ModalOverlay zIndex={1000} />
      <ModalContent
        bg="rgba(0, 0, 0, 0.9)"
        backdropFilter="blur(20px)"
        border="1px solid rgba(255, 255, 255, 0.4)"
        borderRadius="12px"
        color="white"
        overflow="visible"
        position="relative"
        zIndex={1001}
        maxH="90vh"
        overflowY="auto"
        sx={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <ModalHeader color="white">Process Model Properties</ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody overflow="visible" position="relative">
          <Tabs isManual variant="enclosed">
            <TabList>
              <Tab
                color="white"
                _selected={{ color: "brand.500", borderColor: "brand.500" }}
              >
                General
              </Tab>
              <Tab
                color="white"
                _selected={{ color: "brand.500", borderColor: "brand.500" }}
              >
                Variables
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Box
                  borderRadius="8px"
                  bg="rgba(255, 255, 255, 0.05)"
                  border="1px solid rgba(255, 255, 255, 0.4)"
                  p={4}
                  mx={-4}
                  mb={4}
                >
                  <VStack spacing={3} align="stretch">
                    <HStack justify="space-between">
                      <Text
                        fontSize="sm"
                        color="rgba(255, 255, 255, 0.7)"
                        fontWeight="medium"
                      >
                        Created on
                      </Text>
                      <Text fontSize="sm" color="white" fontWeight="semibold">
                        {selectedProcess?.createdOn}
                      </Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text
                        fontSize="sm"
                        color="rgba(255, 255, 255, 0.7)"
                        fontWeight="medium"
                      >
                        Last modified on
                      </Text>
                      <Text fontSize="sm" color="white" fontWeight="semibold">
                        {selectedProcess?.updatedOn}
                      </Text>
                    </HStack>
                  </VStack>
                </Box>
                <Tabs size="md" variant="enclosed" gap={2} mx={-4} my={2}>
                  <TabList>
                    <Tab
                      color="white"
                      _selected={{
                        color: "brand.500",
                        borderColor: "brand.500",
                      }}
                    >
                      English(us)
                    </Tab>
                  </TabList>
                  <TabPanels>
                    <TabPanel gap={2} p={4}>
                      <VStack spacing={4} align="stretch">
                        <HStack spacing={4}>
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            minWidth="30%"
                            textAlign="right"
                            color="rgba(255, 255, 255, 0.7)"
                          >
                            Process Model Id
                          </Text>
                          <Text
                            fontSize="sm"
                            color="white"
                            fontWeight="semibold"
                            flex="1"
                          >
                            {selectedProcess?.id}
                          </Text>
                        </HStack>

                        <HStack spacing={4}>
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            minWidth="30%"
                            textAlign="right"
                            color="rgba(255, 255, 255, 0.7)"
                          >
                            Process Model UUID
                          </Text>
                          <Text
                            fontSize="sm"
                            color="white"
                            fontWeight="semibold"
                            flex="1"
                            wordBreak="break-all"
                          >
                            {selectedProcess?.uuid}
                          </Text>
                        </HStack>

                        <HStack spacing={4} align="flex-start">
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            minWidth="30%"
                            textAlign="right"
                            color="rgba(255, 255, 255, 0.7)"
                            mt={2}
                          >
                            Process Model Name
                          </Text>
                          <Input
                            placeholder="Enter process name"
                            value={selectedProcess?.processNm}
                            contentEditable={false}
                            bg="rgba(255, 255, 255, 0.1)"
                            border="1px solid rgba(255, 255, 255, 0.3)"
                            color="white"
                            _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                            flex="1"
                            size="sm"
                          />
                        </HStack>

                        <HStack spacing={4} align="flex-start">
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            minWidth="30%"
                            textAlign="right"
                            color="rgba(255, 255, 255, 0.7)"
                            mt={2}
                          >
                            Description
                          </Text>
                          <Textarea
                            placeholder="Enter description"
                            value={processDescription}
                            onChange={(e) =>
                              setProcessDescription(e.target.value)
                            }
                            bg="rgba(255, 255, 255, 0.1)"
                            border="1px solid rgba(255, 255, 255, 0.3)"
                            color="white"
                            _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                            _focus={{
                              borderColor: "brand.500",
                              boxShadow: "0 0 0 1px rgba(118, 82, 247, 0.6)",
                            }}
                            flex="1"
                            size="sm"
                            minH="80px"
                          />
                        </HStack>

                        <HStack spacing={4} align="center">
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            minWidth="30%"
                            textAlign="right"
                            color="rgba(255, 255, 255, 0.7)"
                          >
                            Display name
                          </Text>
                          <HStack flex="1" spacing={2}>
                            <Input
                              placeholder="Enter display name"
                              value={processDisplayName}
                              onChange={(e) =>
                                setProcessDisplayName(e.target.value)
                              }
                              bg="rgba(255, 255, 255, 0.1)"
                              border="1px solid rgba(255, 255, 255, 0.3)"
                              color="white"
                              _placeholder={{
                                color: "rgba(255, 255, 255, 0.6)",
                              }}
                              _focus={{
                                borderColor: "brand.500",
                                boxShadow: "0 0 0 1px rgba(118, 82, 247, 0.6)",
                              }}
                              size="sm"
                            />
                            <Icon
                              as={BiEdit as React.ElementType}
                              boxSize="20px"
                              color="brand.500"
                              cursor="pointer"
                              _hover={{ color: "brand.400" }}
                              onClick={onExpressionEditorModalOpen}
                            />
                          </HStack>
                        </HStack>
                      </VStack>
                    </TabPanel>
                  </TabPanels>
                </Tabs>{" "}
              </TabPanel>
              <TabPanel gap={4} overflow="visible" position="relative">
                <Box my={4} overflow="visible">
                  <Table
                    columns={processVariablesColumns}
                    data={processVariablesColumnData}
                    paginationEnabled={false}
                  />
                </Box>
                <Box my={4} overflow="visible">
                  <Table
                    columns={isInstanceBased ? columns1 : columns}
                    data={isInstanceBased ? columnData1 : columnData}
                  />
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
          <HStack justifyContent={"end"}>
            {" "}
            <BrandButton onClick={onUpdate}>Save</BrandButton>
          </HStack>
        </ModalBody>
        <AddProcessVaraibleModal
          isOpen={isPvModelOpen}
          onClose={onPvModeClose}
        />
        <AddProcessVaraibleModal
          isOpen={isPvEditModelOpen}
          onClose={onPvEditModeClose}
          edit={edit}
          ProcessVariable={editProcessVariable}
        />
        <ExpressionEditorModal
          isOpen={isExpressionEditorModalOpen}
          onClose={onExpressionEditorModalClose}
          value={processDisplayName}
          handleValue={handleValue}
        />
      </ModalContent>
    </Modal>
  );
};
